/**
 * ============================================================================
 * SEARCHSPRING BUNDLE CARD CLASSIFIER
 * ============================================================================
 *
 * Watches for SearchSpring to render product cards, then fetches each
 * product's template suffix and bundle badge metafields via a lightweight
 * Liquid endpoint. Cards that use the "bundle" template get the
 * .grid-product--bundle class so existing CSS rules apply, and bundle
 * badge text is injected when present.
 *
 * Handles re-renders from pagination, filtering, and sorting.
 * ============================================================================
 */

(function () {
  'use strict';

  var CONTENT_SELECTOR = '#searchspring-content';
  var CARD_SELECTOR = '.ss__result';
  var BUNDLE_CLASS = 'grid-product--bundle';
  var PROCESSED_ATTR = 'data-bundle-checked';

  // Cache product handle → badge data object to avoid repeat fetches
  var cache = {};

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  function applyBundleData(card, data) {
    if (data.template_suffix !== 'bundle') return;

    card.classList.add(BUNDLE_CLASS);

    // Inject bundle badge if metafield data exists
    var badgeText = data.bundle_text_badge;
    var badgeColor = data.bundle_text_badge_color;
    if (!badgeText) return;

    var meta = card.querySelector('.grid-product__meta');
    if (!meta) return;

    var flexLine = meta.querySelector('.flex-line');
    if (!flexLine) return;

    var flexInline = flexLine.querySelector('.flex-inline');
    if (!flexInline) {
      flexInline = document.createElement('div');
      flexInline.className = 'flex-inline';
      flexLine.prepend(flexInline);
    }

    // Create badge elements matching existing variant badge structure
    var badge = document.createElement('div');
    badge.className = 'grid-product__vendor tagged-product';
    badge.style.color = badgeColor || '';
    badge.textContent = badgeText.toUpperCase();

    flexInline.prepend(badge);
  }

  function processCards() {
    var cards = document.querySelectorAll(CARD_SELECTOR + ':not([' + PROCESSED_ATTR + '])');
    if (cards.length === 0) return;

    cards.forEach(function (card) {
      card.setAttribute(PROCESSED_ATTR, 'true');
      var handle = getHandleFromCard(card);
      if (!handle) return;

      if (cache[handle] !== undefined) {
        applyBundleData(card, cache[handle]);
        return;
      }

      fetch('/products/' + handle + '?view=badge-data')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          cache[handle] = data;
          applyBundleData(card, data);
        })
        .catch(function () {
          // Silently skip — card stays unclassified
        });
    });
  }

  function init() {
    var container = document.querySelector(CONTENT_SELECTOR);
    if (!container) return;

    // Process any cards already rendered
    if (container.innerHTML.length > 100) {
      processCards();
    }

    // Watch for SearchSpring renders and re-renders
    var observer = new MutationObserver(function () {
      // Debounce — wait for SS to finish rendering
      clearTimeout(init._debounce);
      init._debounce = setTimeout(processCards, 300);
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });

    // Fallback poll for initial render
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if (container.innerHTML.length > 100) {
        clearInterval(poll);
        processCards();
      } else if (attempts >= 100) {
        clearInterval(poll);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
